import { render, staticRenderFns } from "./patientDetail.vue?vue&type=template&id=561dae91&"
import script from "./patientDetail.vue?vue&type=script&lang=ts&"
export * from "./patientDetail.vue?vue&type=script&lang=ts&"
import style0 from "./patientDetail.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports